"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _echarts = _interopRequireDefault(require("@/lib/echarts"));

var _resize = _interopRequireDefault(require("../mixins/resize"));

//
//
//
//
var animationDuration = 3000;
var _default = {
  mixins: [_resize.default],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    data: {
      default: []
    },
    mode: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  computed: {
    color: function color() {
      if (this.mode) {
        return '#51f498';
      } else {
        return '#f4516c';
      }
    },
    text: function text() {
      if (this.mode) {
        return this.$t('dashboard.successRate');
      } else {
        return this.$t('dashboard.failureRate');
      }
    },
    indicators: function indicators() {
      if (this.data.length) {
        var res = [];
        this.data.forEach(function (d) {
          res.push({
            name: d.name,
            max: 1
          });
        });
        return res;
      } else {
        return [];
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart(inject) {
      this.chart = _echarts.default.init(this.$el, 'macarons');
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        color: this.color,
        radar: {
          textStyle: {
            color: '#f00'
          },
          radius: '66%',
          center: ['50%', '42%'],
          splitNumber: 8,
          splitArea: {
            areaStyle: {
              color: 'rgba(127,95,132,.3)',
              opacity: 1,
              shadowBlur: 45,
              shadowColor: 'rgba(0,0,0,.5)',
              shadowOffsetX: 0,
              shadowOffsetY: 15
            }
          },
          indicator: this.indicators
        },
        legend: {
          left: 'center',
          bottom: '10',
          data: [this.text]
        },
        series: [{
          type: 'radar',
          // symbolSize: 0,
          areaStyle: {
            normal: {
              shadowBlur: 13,
              shadowColor: 'rgba(0,0,0,.2)',
              shadowOffsetX: 0,
              shadowOffsetY: 10,
              opacity: 1
            }
          },
          data: [{
            value: this.data.map(function (d) {
              return d.value;
            }) || null,
            name: this.text
          }],
          animationDuration: animationDuration
        }]
      });
    }
  }
};
exports.default = _default;